import { t } from 'i18next';
import { useNavigate } from 'react-router-dom';
import { Button } from '@peacecover/component';
import { postToOpener } from './utils/postToOpener';
import { POST_MESSAGES } from './constants/PostMessages';

const RegisterCompletedPage = () => {
  const navigate = useNavigate();
  const handleClose = () => {
    postToOpener(POST_MESSAGES.completedNewTradingPhotoCards);
    if (window.opener) {
      window.close();
    } else {
      navigate('/tradings/photo-cards/sales');
    }
  };
  return (
    <div className="flex flex-col items-center justify-center h-screen">
      <img src="/assets/icons/FoldedHands.png" alt="" className="w-[200px] h-[200px]" />
      <div className="py-[10px] flex flex-col gap-[14px] text-center mt-[23px]">
        <h1 className="font-bold text-[26px] text-text-main-lv1 leading-none">
          {t('DoneTradingPhotoCardsPage.saleTitle')}
        </h1>
        <div>
          <p className="text-[15px] font-medium text-text-main-lv4 leading-tight">
            {t('DoneTradingPhotoCardsPage.description')}
          </p>
        </div>
      </div>
      <div className="px-[24px] absolute bottom-[calc(12px+env(safe-area-inset-bottom))] w-full">
        <Button size="large" className="w-full" onClick={handleClose}>
          {t('confirm')}
        </Button>
      </div>
    </div>
  );
};

export default RegisterCompletedPage;
